// Copyright (c) 2016 Deere & Company

import {
    resetDealerTransferHistoryCriteria,
    updateDealerTransferHistoryCriteria
} from './criteria';

import {createDealerTransferHistoryReport} from './report';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    createDealerTransferHistoryReport,
    resetDealerTransferHistoryCriteria,
    updateDealerTransferHistoryCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/action-creators/index.js